import {
  getClients,
  getClientByID,
  cloneClientAPI,
} from "../../../api/hc360-cloneClient";

const cloneClient = {
  namespaced: true,
  state: {
    defaultClient: null,
    getClientsData: null,
    cloneClientData: null,
    getClientByIDdata: null,
  },

  getters: {
    GET_CLIENT: (state) => state.defaultClient,
  },

  actions: {
    getClients({ state }) {
      return new Promise((resolve, reject) => {
        getClients()
          .then((api_data) => {
            state.getClientsData = api_data;
            resolve(api_data);
          })
          .catch((err) => {
            console.log("getClients store err", err);
            reject(err);
          });
      });
    },

    getClientByID({ state }, params) {
      return new Promise((resolve, reject) => {
        getClientByID(params)
          .then((api_data) => {
            state.getClientByIDdata = api_data;
            resolve(api_data);
          })
          .catch((err) => {
            console.log("getClientByID store err", err);
            reject(err);
          });
      });
    },

    cloneClientStore({ state }, payload) {
      return new Promise((resolve, reject) => {
        console.log(payload);
        cloneClientAPI(payload)
          .then((api_data) => {
            state.cloneClientData = api_data;
            resolve(api_data);
          })
          .catch((err) => {
            console.log("cloneClient store err", err);
            reject(err);
          });
      });
    },
  },

  mutations: {
    SET_CLIENT: (state, data) => {
      state.defaultClient = data;
    },
    RESET_CLIENT: (state) => {
      state.defaultClient = null;
    },
  },
};

export default cloneClient;
